import React from 'react';

import './Filmstrip.css';

export default class Filmstrip extends React.Component {
  constructor(props) {
    super(props);

    this.state = { scrollPosition: 0 };
    this.increment = parseInt(this.props.increment, 10);

    this.setDimensions = this.setDimensions.bind(this);
  }

  componentDidMount() {
    const innerWidth = this.refs.strip.getBoundingClientRect().width,
          viewportWidth = this.refs.viewport.getBoundingClientRect().width;

    if (innerWidth !== this.state.innerWidth || viewportWidth !== this.state.viewportWidth) {
      this.setDimensions(innerWidth, viewportWidth);
    }
  }

  setDimensions(innerWidth, viewportWidth) {
    this.setState({
      innerWidth,
      viewportWidth
    });
  }
  
  adjustPosition(increment) {
    var newPosition = this.state.scrollPosition + increment;
    var offset = this.state.viewportWidth - this.state.innerWidth;

    if (increment > 0) {
      // If we're already at the end, reset
      if (this.state.scrollPosition === 0) {
        newPosition = offset;
      } else {
        newPosition = Math.min(newPosition, 0);
      }
    }

    if (increment < 0) {
      // If we're already at the end, reset
      if (this.state.scrollPosition === offset) {
        newPosition = 0;
      } else {
        newPosition = Math.max(newPosition, offset);
      }
    }

    this.setState({ scrollPosition: newPosition });
  }

  render() {
    const showNavButtons = this.state.innerWidth > this.state.viewportWidth;

    return (
      <section className='filmstrip' ref='filmstrip'>
        <div className='viewport' ref='viewport'>
          <div className='strip' ref='strip' style={{ left: this.state.scrollPosition }}>
            {this.props.children}
          </div>
        </div>
        {
          showNavButtons && 
          <button className='prevNav navButton' onClick={this.adjustPosition.bind(this, this.increment)}>
            <i className="fa fa-angle-left"/>
          </button>
        }
        {
          showNavButtons &&
          <button className='nextNav navButton' onClick={this.adjustPosition.bind(this, -this.increment)}>
            <i className="fa fa-angle-right"/>
          </button>
        }
      </section>
    );
  }
}